import { render, staticRenderFns } from "./Home.pc.vue?vue&type=template&id=6521f3f0&scoped=true&"
import script from "./Home.pc.vue?vue&type=script&lang=js&"
export * from "./Home.pc.vue?vue&type=script&lang=js&"
import style0 from "./Home.pc.vue?vue&type=style&index=0&id=6521f3f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521f3f0",
  null
  
)

export default component.exports